<template>
    <div class="msg-details site-wrapper">
      <div class="guide">
        <span>您的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }"> 首页 </el-breadcrumb-item>
          <el-breadcrumb-item>我的报告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info" style="margin-top: 10px;">
        <el-table v-loading="tableLoading" class="content_table" :data="tableData" style="width: 1168px;margin:  0 auto;">
          <el-table-column :label="item.label" align="center" v-for="(item, index) of tHeader" :key="index">
          <el-table-column :prop="item.post" show-overflow-tooltip align="center">
            <template slot="header" slot-scope="{}">
              <span v-if="item.type === 'input'">
                <el-input v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search"
                  @clear="pageIndex = 1;getDataList()" @blur="pageIndex = 1;getDataList()" placeholder="请输入" />
              </span>
              <span slot="header" v-if="item.type === 'select'">
                <el-select v-model="searchForm[item.spost]" size="mini" clearable prefix-icon="el-icon-search"
                  @clear="pageIndex = 1;getDataList()" @change="pageIndex = 1;getDataList()" placeholder="请选择">
                  <el-option :label="op.label" :value="op.code" v-for="(op, i) of item.options" :key="i"></el-option>
                </el-select>
              </span>
              <span slot="header" v-if="item.type === 'date'">
                <el-date-picker @change="pageIndex = 1;getDataList()" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm[item.post]"
                  style="width: 100%">
                </el-date-picker>
              </span>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row[item.post] || '/' }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column fixed="right" header-align="center" align="center" width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="seeOne(scope.row)">查看报告</el-button>
          </template>
        </el-table-column>
        </el-table>
        <div class="mod-page">
          <pagination layout="prev, pager, next" v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex"
            :limit.sync="pageLimt" @pagination="getDataList" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { dateFtt } from "@/utils";
  import Pagination from "@/components/Pagination";
  export default {
    components: {
      Pagination
    },
    data() {
      return {
        tableLoading: false,
        tableData: [],
        totalPage: 0,
        pageIndex: 1,
        pageLimt: 10,
        tHeader:[
          {
            label:"报告编号",
            post:"reportNo",
            type:"input"
          },
          {
            label:"生成时间",
            post:"addTime",
            type:"date"
          },
          {
            label:"单位名称",
            post:"orgWtName",
            type:"input"
          },
          {
            label:"样品名称",
            post:"sampleName",
            type:"input"
          },
          {
            label:"样品型号",
            post:"sampleSpecName",
            type:"input"
          },
          {
            label:"检测结果",
            post:"determination",
            type:"select",
            spost:"isQualified",//下拉框传参
            options:[
              {
                label:"合格",
                code:true
              },
              {
                label:"不合格",
                code:false
              },
              {
                label:"不做判定",
                code:'other'
              }
            ]
          }
        ],
        searchForm:{}
      };
    },
    created() {
      this.getDataList();
    },
    methods: {
      seeOne(row) {
        // if (window.navigator.msSaveOrOpenBlob) {
        //   // IE version
        //   var blob = new Blob([row.repPreUri], { type: 'application/force-download' })
        //   window.navigator.msSaveOrOpenBlob(blob)
        // } else {
          window.open(window.SITE_CONFIG["baseUrl"]+'/checkmall-file/api/file/previewFile?fileCode='+ row.repPreUri);
        // }
      },
      getDataList() {
        this.tableLoading = true;
        let params = {
          current: this.pageIndex,
          size: this.pageLimt,
          data: this.searchForm
        }
        this.$http.post(this.$api.orderApi.myReport, params).then(({ data }) => {
          this.tableLoading = false;
          data.data.list.forEach(v => {
            if(v.addTime){
              v.addTime = dateFtt(new Date(v.addTime),1);
            }
          })
          this.tableData = data.data.list;
          this.totalPage = data.data.total;
        }).catch(()=>{
            this.tableLoading = false;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .msg-details {
    position: relative;
  
    .guide {
      display: flex;
      margin-bottom: 0;
    }
  
    .info {
      min-height: 703px;
      padding-top: 16px;
      background: #fff;
      border-radius: 16px;
      margin-bottom: 56px;
    }
  
    .add {
      margin-bottom: 10px;
      text-align: right;
  
      button {
        padding: 8px 25px;
        font-size: 14px;
      }
    }
  
    .el-table .el-button {
      padding: 0;
    }
  }
  </style>
  